<template>
    <div class="report-twoday">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">

                </div>
                <div class="button-group">
                    <!--<el-button type="primary" icon="el-icon-search" @click="occupancyrate">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>

            </div>

            <div class="table-content">
                <el-table class="table-head" :data="twodaydata" border>
                    <el-table-column align="center" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="title" label="房间名称" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="ccode" label="集中器编码" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="pcode" label="设备编码" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="name" label="姓名" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="phone" label="手机号" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="addr" label="地址" min-width="120" show-overflow-tooltip></el-table-column>
                    <!--<el-table-column align="center" prop="staydate" label="操作" min-width="50">-->
                        <!--<template slot-scope="scope">-->
                            <!--<el-button @click="toHouse(scope.$index, outagedata)" type="text" size="small">查看</el-button>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "ReportTwoday",
        data() {
            return{
                twodaydata:[],
            }
        },
        mounted(){
            this.Twodaydata();
        },
        methods:{
            Twodaydata(){
                this.$http.get(`${store.state.url}zone/room/0/300?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            let twodaydata = [];
                            if(res.Data!=null) {
                                for (let i in res.Data) {
                                    twodaydata[i] = {
                                        title: res.Data[i].Title,
                                        ccode: res.Data[i].Ccode,
                                        pcode: res.Data[i].Pcode,
                                        addr: res.Data[i].Addr,
                                        name:res.Data[i].Name,
                                        phone:res.Data[i].Phone,
                                        devid: res.Data[i].Uuid,
                                    }
                                }
                            }
                        this.twodaydata = twodaydata;
                    }else {
                    this.twodaydata =[];
                    this.$message(res.Message);
                }
                    })
            },
            //导出excel
            downloadMater() {
                const defaultCellStyle = {
                    font: {name: "Verdana", sz: 11, color: "FF00FF88"},
                    fill: {fgColor: {rgb: "FFFFAA00"}}
                };
                const wopts = {
                    bookType: 'xlsx',
                    bookSST: false,
                    type: 'binary',
                    defaultCellStyle: defaultCellStyle,
                    showGridLines: false
                };
                const wb = {SheetNames: ['Sheet1'], Sheets: {}, Props: {}};

                let Data = [];
                for (let i in this.twodaydata) {
                    Data[i] = {
                        房间名称: this.twodaydata[i].title,
                        集中器编码: this.twodaydata[i].ccode,
                        设备编码: this.twodaydata[i].pcode,
                        姓名: this.twodaydata[i].name,
                        手机号: this.twodaydata[i].phone,
                        地址: this.twodaydata[i].addr,
                    };
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {type: "application/octet-stream"})
                FileSaver.saveAs(tmpDown, "两天无个人用电报表.xls");
            },
            //字符串转字符流
            s2ab(s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },


        }

    }
</script>

<style scoped>
    .button-group{
        margin-right:0.05rem;
    }

</style>